import React from "react";
import { vibesColors as colors } from "../../theme/vibesColors";

export default function ErrorMessage({ message }) {
  return (
    <div
      className="container py-5 px-3"
      style={{ color: colors.red }}
      role="alert"
    >
      <p className="mb-0 text-center">{message}</p>
    </div>
  );
}
